import React from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/Dialog';
export function FooterSection() {
  return <footer className="w-full bg-[#1B4332] py-8" data-id="element-10">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-11">
        <div className="flex flex-col items-center gap-4" data-id="element-12">
          <div className="flex items-center gap-6" data-id="element-13">
            <Dialog data-id="element-14">
              <DialogTrigger className="text-white/70 hover:text-white text-sm underline-offset-4 hover:underline transition-colors cursor-pointer" data-id="element-15">
                Política de Privacidad
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-16">
                <DialogHeader data-id="element-17">
                  <DialogTitle data-id="element-18">Política de Privacidad</DialogTitle>
                  <DialogDescription data-id="element-19">
                    Última actualización: Abril 2026
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-20">
                  <h3 className="font-semibold text-base text-gray-900" data-id="element-21">
                    1. Información que Recopilamos
                  </h3>
                  <p data-id="element-22">
                    Recopilamos la información que nos proporcionas directamente
                    al realizar una compra, incluyendo tu nombre, dirección de
                    correo electrónico y datos de pago. Los datos de pago son
                    procesados de forma segura por nuestro proveedor de pagos y
                    no almacenamos información de tarjetas de crédito en
                    nuestros servidores.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-23">
                    2. Uso de la Información
                  </h3>
                  <p data-id="element-24">
                    Utilizamos tu información personal exclusivamente para
                    procesar tu pedido, enviarte el producto digital adquirido y
                    comunicarnos contigo sobre tu compra. No vendemos,
                    alquilamos ni compartimos tu información personal con
                    terceros con fines de marketing.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-25">
                    3. Cookies y Tecnologías de Seguimiento
                  </h3>
                  <p data-id="element-26">
                    Nuestro sitio web puede utilizar cookies esenciales para el
                    funcionamiento básico del sitio y cookies analíticas para
                    comprender cómo los visitantes interactúan con nuestra
                    página. Puedes desactivar las cookies en la configuración de
                    tu navegador.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-27">
                    4. Seguridad de los Datos
                  </h3>
                  <p data-id="element-28">
                    Implementamos medidas de seguridad técnicas y organizativas
                    apropiadas para proteger tu información personal contra el
                    acceso no autorizado, la alteración, divulgación o
                    destrucción.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-29">
                    5. Tus Derechos
                  </h3>
                  <p data-id="element-30">
                    Tienes derecho a acceder, rectificar o eliminar tus datos
                    personales en cualquier momento. También puedes solicitar la
                    portabilidad de tus datos o limitar su procesamiento
                    conforme a la normativa vigente de protección de datos
                    (RGPD).
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-31">
                    6. Cambios en esta Política
                  </h3>
                  <p data-id="element-32">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Cualquier cambio será
                    publicado en esta página con la fecha de actualización
                    correspondiente.
                  </p>
                </div>
              </DialogContent>
            </Dialog>

            <span className="text-white/30" data-id="element-33">|</span>

            <Dialog data-id="element-34">
              <DialogTrigger className="text-white/70 hover:text-white text-sm underline-offset-4 hover:underline transition-colors cursor-pointer" data-id="element-35">
                Términos y Condiciones
              </DialogTrigger>
              <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" data-id="element-36">
                <DialogHeader data-id="element-37">
                  <DialogTitle data-id="element-38">Términos y Condiciones</DialogTitle>
                  <DialogDescription data-id="element-39">
                    Última actualización: Abril 2026
                  </DialogDescription>
                </DialogHeader>
                <div className="space-y-4 text-sm text-gray-700 leading-relaxed" data-id="element-40">
                  <h3 className="font-semibold text-base text-gray-900" data-id="element-41">
                    1. Aceptación de los Términos
                  </h3>
                  <p data-id="element-42">
                    Al acceder a este sitio web y realizar una compra, aceptas
                    estos términos y condiciones en su totalidad. Si no estás de
                    acuerdo con alguno de estos términos, te rogamos que no
                    utilices nuestro sitio ni adquieras nuestros productos.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-43">
                    2. Producto Digital
                  </h3>
                  <p data-id="element-44">
                    El producto ofrecido es una guía digital en formato PDF. Una
                    vez completada la compra, recibirás acceso inmediato para
                    descargar el material. El contenido es exclusivamente para
                    uso personal y no puede ser redistribuido, revendido ni
                    compartido sin autorización expresa.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-45">
                    3. Precio y Pago
                  </h3>
                  <p data-id="element-46">
                    El precio del producto se muestra en dólares estadounidenses
                    (USD). El pago se realiza de forma única, sin suscripciones
                    ni cargos recurrentes. Todos los pagos son procesados de
                    forma segura a través de nuestro proveedor de pagos
                    autorizado.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-47">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-48">
                    Debido a la naturaleza digital del producto, una vez
                    descargado no se aceptan devoluciones. Sin embargo, si
                    experimentas problemas técnicos con la descarga, nos
                    comprometemos a resolverlos para garantizar que recibas tu
                    producto.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-49">
                    5. Propiedad Intelectual
                  </h3>
                  <p data-id="element-50">
                    Todo el contenido de este sitio web y del producto digital,
                    incluyendo textos, imágenes, diseños y logotipos, está
                    protegido por derechos de autor. Queda prohibida su
                    reproducción total o parcial sin consentimiento previo por
                    escrito.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-51">
                    6. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-52">
                    Los resultados obtenidos con la guía pueden variar según las
                    condiciones individuales de cada usuario (clima, espacio,
                    dedicación). No garantizamos resultados específicos. La
                    información proporcionada es de carácter educativo y
                    orientativo.
                  </p>

                  <h3 className="font-semibold text-base text-gray-900" data-id="element-53">
                    7. Legislación Aplicable
                  </h3>
                  <p data-id="element-54">
                    Estos términos se rigen por la legislación vigente.
                    Cualquier disputa será resuelta ante los tribunales
                    competentes de la jurisdicción correspondiente.
                  </p>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          <p className="text-white/50 text-xs" data-id="element-55">
            © {new Date().getFullYear()} Maestría en Huerto Urbano. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}